"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Button = require("../form/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Spinner = require("../Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _VoucherUtil = require("../../utils/VoucherUtil");

var util = _interopRequireWildcard(_VoucherUtil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherOrderConfirmation = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(VoucherOrderConfirmation, _Component);

  function VoucherOrderConfirmation() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherOrderConfirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherOrderConfirmation.__proto__ || (0, _getPrototypeOf2.default)(VoucherOrderConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.handlePayTrailClick = function (event) {
      event.preventDefault();
      var payload = _this.createOrderBody("WEB_PAYMENT");
      _this.props.placeOrder(payload);
    }, _this.handleInvoiceClick = function (event) {
      event.preventDefault();
      var payload = _this.createOrderBody("INVOICE");
      _this.props.placeOrder(payload);
    }, _this.createItems = function () {
      var _this$props = _this.props,
          cart = _this$props.vouchers.cart,
          orderType = _this$props.orderType;


      return cart.map(function (item) {
        switch (orderType) {
          case "reception":
            item.soil_reception_place_id = item.id;
            break;
          case "pickup":
            item.soil_pickup_place_id = item.id;
            break;
          default:
            break;
        }
        return item;
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherOrderConfirmation, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Tilausvahvistus" }),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "button",
            {
              className: "confirmation-button-back back-button-js",
              onClick: this.props.onBack
            },
            "Takaisin"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12 confirmation-items" },
          _react2.default.createElement(
            "h2",
            { className: "h4" },
            "Tilausvahvistus:"
          ),
          _react2.default.createElement(
            "table",
            { className: "table " },
            _react2.default.createElement(
              "tbody",
              null,
              this.renderCart(),
              _react2.default.createElement(
                "tr",
                { className: "confirmation-item" },
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    "Tilaus yhteens\xE4:"
                  )
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  "\xA0"
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  "\xA0"
                ),
                _react2.default.createElement(
                  "td",
                  null,
                  _react2.default.createElement(
                    "b",
                    null,
                    this.getPrice()
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12 col-sm-6 confirmation-info" },
          _react2.default.createElement(
            "h2",
            { className: "h4" },
            "Tilaaja:"
          ),
          this.renderCompanyInfo(),
          this.renderPersonInfo(),
          this.renderOrderReference()
        ),
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12 col-sm-4 col-sm-offset-2" },
          _react2.default.createElement(
            "h2",
            { className: "h4 voucher-payment-title" },
            "Siirry maksamaan:"
          ),
          _react2.default.createElement(
            "div",
            { className: "confirmation-buttons confirmation-info-section" },
            this.renderSpinner(),
            _react2.default.createElement(_Button2.default, {
              text: "Verkkomaksu",
              additionalClasses: "button-set-width paytrail-button-js",
              onClick: this.handlePayTrailClick
            })
          ),
          _react2.default.createElement(
            "h5",
            { className: "h5 paytrail-payment-terms" },
            "Maksupalvelutarjoaja"
          ),
          _react2.default.createElement(
            "div",
            { className: "paytrail-payment-info" },
            _react2.default.createElement(
              "p",
              null,
              "Maksunv\xE4lityspalvelun toteuttajana ja maksupalveluntarjoajana toimii Paytrail Oyj (2122839-7) yhteisty\xF6ss\xE4 suomalaisten pankkien ja luottolaitosten kanssa. Paytrail Oyj n\xE4kyy maksun saajana tiliotteella tai korttilaskulla ja v\xE4litt\xE4\xE4 maksun kauppiaalle. Paytrail Oyj:ll\xE4 on maksulaitoksen toimilupa. Reklamaatiotapauksissa pyyd\xE4mme ottamaan ensisijaisesti yhteytt\xE4 tuotteen toimittajaan."
            ),
            _react2.default.createElement(
              "p",
              null,
              "Paytrail Oyj, y-tunnus: 2122839-7",
              _react2.default.createElement("br", null),
              "Innova 2",
              _react2.default.createElement("br", null),
              "Lutakonaukio 7",
              _react2.default.createElement("br", null),
              "40100 Jyv\xE4skyl\xE4"
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "a",
                {
                  href: "https://www.paytrail.com/kuluttaja/tietoa-maksamisesta",
                  target: "_blank",
                  rel: "noopener noreferrer"
                },
                "Tietoa maksamisesta"
              )
            )
          )
        ),
        this.renderError()
      );
    }
  }, {
    key: "renderCart",
    value: function renderCart() {
      var cart = this.props.vouchers.cart;

      return cart.map(function (item) {
        return _react2.default.createElement(
          "tr",
          { key: item.id, className: "confirmation-item confirmation-item-js" },
          _react2.default.createElement(
            "td",
            null,
            item.name
          ),
          _react2.default.createElement(
            "td",
            null,
            util.priceWithVAT(item),
            " / kpl"
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "span",
              { className: "small" },
              "\u2715"
            ),
            " ",
            item.quantity
          ),
          _react2.default.createElement(
            "td",
            null,
            util.totalPriceWithVAT(item)
          )
        );
      });
    }
  }, {
    key: "renderCompanyInfo",
    value: function renderCompanyInfo() {
      var _props$values = this.props.values,
          business_id = _props$values.business_id,
          company_name = _props$values.company_name;


      if (business_id && company_name) {
        return _react2.default.createElement(
          "div",
          { className: "confirmation-info-section" },
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              "b",
              null,
              "Yritys:"
            )
          ),
          _react2.default.createElement(
            "p",
            null,
            business_id
          ),
          _react2.default.createElement(
            "p",
            null,
            company_name
          ),
          this.renderAddress()
        );
      }
    }
  }, {
    key: "renderPersonInfo",
    value: function renderPersonInfo() {
      var _props$values2 = this.props.values,
          first_name = _props$values2.first_name,
          last_name = _props$values2.last_name,
          phone = _props$values2.phone,
          email = _props$values2.email,
          business_id = _props$values2.business_id,
          company_name = _props$values2.company_name;

      return _react2.default.createElement(
        "div",
        { className: "confirmation-info-section" },
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "b",
            null,
            "Henkil\xF6tiedot:"
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          first_name,
          " ",
          last_name
        ),
        !business_id && !company_name && this.renderAddress(),
        _react2.default.createElement(
          "p",
          null,
          phone
        ),
        _react2.default.createElement(
          "p",
          null,
          email
        )
      );
    }
  }, {
    key: "renderAddress",
    value: function renderAddress() {
      var _props$values3 = this.props.values,
          address = _props$values3.address,
          postal_code = _props$values3.postal_code,
          city = _props$values3.city;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "p",
          null,
          address,
          ", ",
          postal_code,
          " ",
          city
        )
      );
    }
  }, {
    key: "renderOrderReference",
    value: function renderOrderReference() {
      var order_reference = this.props.values.order_reference;

      return _react2.default.createElement(
        "div",
        { className: "confirmation-info-section" },
        _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "b",
            null,
            "Tilausviite:"
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          order_reference
        )
      );
    }
  }, {
    key: "renderInvoiceButton",
    value: function renderInvoiceButton() {
      var company = this.props.company;

      if (!company) {
        return null;
      } else if (company && !company.allow_invoicing) {
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            _Button2.default,
            {
              disabled: true,
              text: "Lasku",
              additionalClasses: "button-set-width invoice-button-js",
              onClick: this.handleInvoiceClick
            },
            _react2.default.createElement(
              "p",
              { className: "small info-text-js" },
              "Ottaaksesi laskutuksen k\xE4ytt\xF6\xF6n",
              _react2.default.createElement("br", null),
              "ota yhteytt\xE4 Maap\xF6rssiin."
            )
          )
        );
      } else {
        return _react2.default.createElement(_Button2.default, {
          text: "Lasku",
          additionalClasses: "button-set-width invoice-button-js",
          onClick: this.handleInvoiceClick
        });
      }
    }
  }, {
    key: "renderError",
    value: function renderError() {
      if (this.props.vouchers.placeOrderError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "error-message confirmation-error" },
            "Tilauksen aikana tapahtui virhe. Yrit\xE4 my\xF6hemmin uudelleen."
          )
        );
      }
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      if (this.props.vouchers.placeOrderLoading) {
        return _react2.default.createElement(_Spinner2.default, { additionalClasses: "confirmation-spinner" });
      }
    }
  }, {
    key: "getPrice",
    value: function getPrice() {
      var cart = this.props.vouchers.cart;

      var price = 0;
      cart.forEach(function (item) {
        price += item.price * item.quantity;
      });
      return util.priceWithVAT({ price: price });
    }
  }, {
    key: "createOrderBody",
    value: function createOrderBody(payment_method) {
      var values = this.props.values;

      return (0, _extends3.default)({}, values, {
        items: this.createItems(),
        payment_method: payment_method
      });
    }
  }]);
  return VoucherOrderConfirmation;
}(_react.Component), _class.propTypes = {
  values: _react.PropTypes.object.isRequired,
  onBack: _react.PropTypes.func.isRequired,
  placeOrder: _react.PropTypes.func.isRequired,
  company: _react.PropTypes.object,
  vouchers: _react.PropTypes.object.isRequired,
  orderType: _react.PropTypes.string.isRequired
}, _temp2);
exports.default = VoucherOrderConfirmation;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/VoucherOrderConfirmation.js
 ** module id = 486
 ** module chunks = 0
 **/